import getConfig from 'next/config';
import { setIsMarginPair } from '../actions/load';
import {
  setMarginSymbols,
  fetchMarginSymbols,
} from '../actions/actionsSet/margin';

const {
  publicRuntimeConfig: { mktdataWssUrl: WSS_URL, enableMargin },
} = getConfig();

// margin
export const handleMarginSymbolsTask = (store, req, both) => {
  if (!enableMargin) return {};
  return fetchMarginSymbols(req).then(symbols => {
    store.dispatch(setMarginSymbols(symbols));
    if (Array.isArray(both)) {
      // trade page
      symbols.filter(k => k.base === both[0]).filter(m => m.quote === both[1]).length
        ? store.dispatch(setIsMarginPair(true))
        : store.dispatch(setIsMarginPair(false));
    }
  });
};

export const wssUri = () => WSS_URL;
